export default __webpack_public_path__ + "static/curriculum-learn-coding-e5d82d0bdc608d4de740d894f93a411c.webp";